

exports.__esModule = true;

var _squid = require('squid');

var _util = require('xo-return-to-merchant/dist/util');

var _logger = require('xo-beaver/dist/logger');

require('components/xo-ui-components/src/modal/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

var _uiRouter = require('uiRouter');

var _angular = require('angular');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoSoldoutPageDirective', {
    tag: 'xo-soldout-page',
    template: _template2['default'],
    auth: false,
    actions: {
        continueShoppingHandler: function continueShoppingHandler() {
            if (window.opener && !window.opener.closed) {
                _logger.$logger.info('continue_shopping_target_not_self');
                try {
                    window.opener.location.href = _angular.$rootScope.soldoutUrl;
                } catch (err) {
                    _logger.$logger.info('window_opener_location_error', { err: err });
                } finally {
                    self.close();
                }
            } else {
                _logger.$logger.info('continue_shopping_target_self');
                _util.$ReturnToMerchant.goTo(_angular.$rootScope.soldoutUrl, true);
            }
        },
        continueShoppingCartHandler: function continueShoppingCartHandler() {
            return _uiRouter.$state.go('checkout.shoppingCart', { noUpdateRequired: true });
        }
    },
    lifecycle: {
        enter: function enter() {
            this.locale = _squid.$locale;
            angular.element('.paypalHeader').css('display', 'none');
            angular.element('#defaultCancelLink').css('display', 'none');
        },
        populate: function populate() {
            this.flow = _squid.$config.flow;
            this.item_name = decodeURIComponent(_uiRouter.$state.params.items);
            this.count = decodeURIComponent(_uiRouter.$state.params.count);
            this.messageKey = 'soldout.message';

            if (this.count === 'many') {
                this.item_name = JSON.parse(this.item_name);
                this.messageKey = 'soldout.twoItemMessage';
                this.items = this.item_name.slice(0, this.item_name.length - 1).join(', ');
                this.lastItem = this.item_name[this.item_name.length - 1];
            } else if (this.count === 'all') {
                this.messageKey = 'soldout.allItemMessage';
            }
        }
    }
});


_squid.$Component;

_squid.$locale;

_squid.$config;

_util.$ReturnToMerchant;

_logger.$logger;

_uiRouter.$state;

_angular.$rootScope;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./pages/xo-inventory-soldout/directive.js
// module id = ./pages/xo-inventory-soldout/directive.js
// module chunks = 1